import { Directive, ElementRef, HostBinding, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'input[type="numberText"]'
})
export class InputNumberTextDirective {

  @Input() isValid : (score : number) => boolean;
  // @HostBinding("value") value : string;
  @HostBinding() min : number;
  @HostBinding() max : number;

  constructor(private ele : ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(e : KeyboardEvent){
    if(e.code == "Backspace" || e.code == "Enter" || e.code.startsWith("Arrow")) return;

    if (e.code == "Space" || isNaN(<number><unknown>e.key)) {
      e.preventDefault();
      return;
    }

    if(this.ele.nativeElement.value == '') return;

    let currVal : number = +(this.ele.nativeElement.value + e.key);
    if(!this.isValid(currVal)) e.preventDefault();
  }
 
}
